import { render, staticRenderFns } from "./SupEdit.vue?vue&type=template&id=006ebd8c&scoped=true"
import script from "./SupEdit.vue?vue&type=script&lang=js"
export * from "./SupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ebd8c",
  null
  
)

export default component.exports